import {Box, Button, Columns, Form, Tabs} from "react-bulma-components";
import {Pagination} from "react-bulma-components";
import React, {Component, useState} from "react";
import Figure from "../Homepage/Figure";
import FilterHeading from "../Invoicing/FilterHeading";
import {readableDate} from "../../utils";
import axios from "axios";
import {useDispatch} from "react-redux";
import {createSetDataFreshAction, createSetRentalsDataAction} from "../../actions/dataActions";
import useInlineEditButton from "../../hooks/useInlineEditButton";
import FAIcon from "../Icon/FAIcon";
import VehicleRentalRow from "./VehicleRentalRow";
import {NotificationManager} from "react-notifications";

export default function VehicleRentalView(props) {
  const dispatch = useDispatch();

  const dateFields = [
    "data_of_quote_received"
  ];

  const fixEmptyDates = rental => {
    dateFields.forEach(function (date) {
      if (rental[date] === "") {
        rental[date] = null;
      }
    });
    return rental;
  };

  const onVehicleSave = (index) => {
        // this needs to send a request to the qc endpoint
        const conf = {
            url: "api/vehicles/qc",
            data: props.rentals[index].vehicle,
            method: "put"
        }

        axios(conf).then(res => {
            dispatch(createSetDataFreshAction(props.dataFresh + 1));
        }).catch(err => {
            NotificationManager.error("There was an error saving vehicle")
        })
    }

    const onRentalSave = (index) => {
      let data = props.rentals[index]
      data = fixEmptyDates(data);
      const conf = {
          url: `/api/rentals/${data.id}`,
          method: "put",
          data: data
      }
      axios(conf).then(res => {
          dispatch(createSetDataFreshAction(props.dataFresh + 1))
      }).catch(err => {
          NotificationManager.error("There was an error saving rental")
      })
    }

    const onChange = (e, index) => {
        let newRental = {...props.rentals[index], [e.target.name]: e.target.value};
        props.rentals[index] = newRental;
        dispatch(createSetRentalsDataAction(props.rentals));
    }

    const onMultiFieldChange = (data, index) => {
      let newRental = {...props.rentals[index]};
      for (const [key, value] of Object.entries(data)) {
          // loop through all key value pairs of passed data
          // assign them to new rental
          newRental[key] = value;
      }
      props.rentals[index] = newRental;
      dispatch(createSetRentalsDataAction(props.rentals));
    }

    const onQcCheck = (e, index) => {
        let newRental = {...props.rentals[index]}
        newRental.vehicle[e.target.name] = !newRental.vehicle[e.target.name]
        props.rentals[index] = newRental;
        dispatch(createSetRentalsDataAction(props.rentals));
    }



    return (
      <Box>
        <h1 className="title">Rentals{props.dateRangeString ? props.dateRangeString : ""}</h1>
        <Tabs type={"toggle"} fullwidth align={"centered"}>
            {props.view === "weekly" && props.dayInput}
            <Columns.Column></Columns.Column>
            <Columns.Column></Columns.Column>
            <Columns.Column></Columns.Column>
        </Tabs>
        <Columns>
            <Columns.Column>
                <Figure label="Total Estimated Long Term Weekly Rate" value={props.total_long_term} loaded={props.total_long_term}/>
            </Columns.Column>
            <Columns.Column>
                <Figure label="Total Estimated Short Term Weekly Rate" value={props.total_short_term} loaded={props.total_short_term}/>
            </Columns.Column>
        </Columns>
        <Tabs type="toggle" align="centered">
          <Tabs.Tab
            active={props.view === "all"}
            onClick={() => props.onViewChange("all")}
          >
            All
          </Tabs.Tab>
          <Tabs.Tab
            active={props.view === "all_hire"}
            onClick={() => props.onViewChange("all_hire")}
          >
            All On Hire
          </Tabs.Tab>
          <Tabs.Tab
            active={props.view === "weekly"}
            onClick={() => props.onViewChange("weekly")}
          >
            Weekly
          </Tabs.Tab>
          <Tabs.Tab
            active={props.view === "onhires"}
            onClick={() => props.onViewChange("onhires")}
          >
            Upcoming Onhires
          </Tabs.Tab>
          <Tabs.Tab
            active={props.view === "offhires"}
            onClick={() => props.onViewChange("offhires")}
          >
            Upcoming Offhires
          </Tabs.Tab>
          <Tabs.Tab
            active={props.view === "insurance"}
            onClick={() => props.onViewChange("insurance")}
          >
            Insurance Expiries
          </Tabs.Tab>
          <Tabs.Tab
            active={props.view === "unfinished_off"}
            onClick={() => props.onViewChange("unfinished_off")}
          >
            Unfinished Offhires
          </Tabs.Tab>
          <Tabs.Tab
            active={props.view === "awaiting_quote"}
            onClick={() => props.onViewChange("awaiting_quote")}
          >
            Awaiting Estimate
          </Tabs.Tab>
          <Tabs.Tab
            active={props.view === "over_mileage"}
            onClick={() => props.onViewChange("over_mileage")}
          >
            Over Mileage
          </Tabs.Tab>
          <Tabs.Tab
            active={props.view === "quotes"}
            onClick={() => props.onViewChange("quotes")}
          >
            Quotes
          </Tabs.Tab>
          <Tabs.Tab
            active={props.view === "nr"}
            onClick={() => props.onViewChange("nr")}
          >
            Not Required
          </Tabs.Tab>
        </Tabs>
        <table className="table is-hoverable is-fullwidth is-striped">
          <thead>
          <tr>
            <th>ID</th>
            <FilterHeading
                key={"vehicle__registration"}
                heading={{label: "Registration", field: "vehicle__registration", labelField: "vehicle__registration"}}
                setFilters={f => {
                    props.onPageChange(1);
                    props.setFilters(f);
                }}
                filters={props.filters}
                options={props.filterList.vehicle__registration}
            />
            <FilterHeading
              key='rental_type'
              heading={{label: "Type", field: "rental_type", labelField: "rental_type"}}
              setFilters={f => {
                props.onPageChange(1);
                props.setFilters(f);
              }}
              filters={props.filters}
              options={props.filterList.rental_type}
            />
            <th>Tracker Hire</th>
            <FilterHeading
              key='chargeable_date'
              heading={{date: true, label: "Start Date", field: "chargeable_date", labelField: "chargeable_date"}}
              setFilters={f => {
                props.onPageChange(1);
                props.setFilters(f);
              }}
              filters={props.filters}
              options={props.filterList.chargeable_date}
            />
            <FilterHeading
              key='end_date'
              heading={{date: true, label: "End Date", field: "finish_date", labelField: "finish_date"}}
              setFilters={f => {
                props.onPageChange(1);
                props.setFilters(f);
              }}
              filters={props.filters}
              options={props.filterList.finish_date}
            />
            <FilterHeading
              key='customer'
              heading={{label: "Customer", field: "customer", labelField: "customer__display_name"}}
              setFilters={f => {
                props.onPageChange(1);
                props.setFilters(f);
              }}
              filters={props.filters}
              options={props.filterList.customer}
            />
            <FilterHeading
              key='make'
              heading={{label: "Make", field: "vehicle__make", labelField: "vehicle__make__name"}}
              setFilters={f => {
                props.onPageChange(1);
                props.setFilters(f);
              }}
              filters={props.filters}
              options={props.filterList.make}
            />
            <FilterHeading
              key='model'
              heading={{label: "Model", field: "vehicle__model", labelField: "vehicle__model__name"}}
              setFilters={f => {
                props.onPageChange(1);
                props.setFilters(f);
              }}
              filters={props.filters}
              options={props.filterList.model}
            />
              <FilterHeading
              key='type'
              heading={{label: "Type", field: "vehicle__type", labelField: "vehicle__type__name"}}
              setFilters={f => {
                props.onPageChange(1);
                props.setFilters(f);
              }}
              filters={props.filters}
              options={props.filterList.type}
            />
            {props.view !== "awaiting_quote" && <th>Daily Rate</th>}
            {props.view !== "awaiting_quote" && <th>Daily Finance Payment</th>}
            {props.view !== "awaiting_quote" && <th>Rate Card</th>}
            {props.view !== "awaiting_quote" && <th>Invoice Interval</th>}
            <th>Comments</th>
            {props.view === "unfinished_off" && <th>Off Hire Comments</th>}
            {props.view === "unfinished_off" && <th>Missing Items</th>}
            {props.view === "awaiting_quote" && <th>Damage Indicated Date</th>}
            {props.view === "awaiting_quote" && <th>Quote Received</th>}
            {props.view === "awaiting_quote" && <th>Quote Received Date</th>}
            {props.view === "awaiting_quote" && <th>Quote Amount</th>}
            <th>Qc Check</th>
          </tr>
          </thead>
          <tbody>
          {props.rentals.map((value, index) => (
              <VehicleRentalRow
                value={value}
                index={index}
                onChange={onChange}
                onQcCheck={onQcCheck}
                onVehicleSave={onVehicleSave}
                onRentalSave={onRentalSave}
                view={props.view}
                getMissingOffHireItems={props.getMissingOffHireItems}
                onMultiChange={onMultiFieldChange}
              />
          ))}
          </tbody>
        </table>
        {/*<Pagination*/}
        {/*  showFirstLast={true}*/}
        {/*  onChange={page => props.onPageChange(page)}*/}
        {/*  current={props.current}*/}
        {/*  total={Math.ceil(props.count / 25)}*/}
        {/*/>*/}
      </Box>
    );
}
